import { type FC } from 'react';

import { Box } from '../Box';
import { Divider } from '../Divider';
import { Heading, Text } from '../Typography';
import { type SelectableOptionSectionProps } from './SelectableOptionSection.types';

const SelectableOptionSection: FC<SelectableOptionSectionProps> = ({
  title,
  description,
  showDivider = false,
  children,
  className,
  ...rest
}) => {
  return (
    <Box
      className={className}
      display="flex"
      flexDirection="column"
      width="100%"
      {...rest}
    >
      {showDivider ? <Divider my="var(--spacing-5)" /> : null}

      <Heading size="2xs" fontWeight="bold">
        {title}
      </Heading>

      {description ? (
        <Box mb="var(--spacing-4)">
          <Text as="span" size="sm">
            {description}
          </Text>
        </Box>
      ) : null}

      <Box display="flex" flexDirection="column" gap="var(--spacing-3)">
        {children}
      </Box>
    </Box>
  );
};

SelectableOptionSection.displayName = 'SelectableOptionSection';

export default SelectableOptionSection;
